import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { InventoryPartListParams } from '../../../types/inventory/inventoryTypes'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

let prevController: AbortController | null = null

const loadInventoryFacets =
    (params: InventoryPartListParams) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        if (prevController) {
            prevController.abort()
        }

        const controller = new AbortController()
        const { signal } = controller
        prevController = controller

        const { userData } = getState()

        dispatch({ type: storeDispatchTypes.setInventoryFacetsLoading, value: true })

        try {
            const response = await apiInstance.post(
                '/inventory/getInventoryFacets',
                {
                    userId: userData.smsAuth.userId,
                    params: {
                        ...params,
                        pagination: undefined,
                        order: undefined,
                        includeFacets: undefined,
                    },
                },
                {
                    headers: {
                        Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
                    },
                    signal,
                },
            )

            if (response?.data?.facets) {
                dispatch({
                    type: storeDispatchTypes.setInventoryFacets,
                    value: response.data.facets,
                })
            }
        } catch (e) {
            if (!signal.aborted) {
                console.error('load inventory facets failed', e)
            }
        } finally {
            if (!signal.aborted) {
                dispatch({
                    type: storeDispatchTypes.setInventoryFacetsLoading,
                    value: false,
                })
            }
        }
    }

export default loadInventoryFacets
